import type { Cache, UpdatesConfig, Variables } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { KaminoReportableUnitCreateGranadaXlcMutation } from '@/graphql/generated/graphql';

const reportableUnitMutations: UpdatesConfig['Mutation'] = {
  kaminoReportableUnitCreateGranadaXlc: (data: KaminoReportableUnitCreateGranadaXlcMutation, __: Variables, cache: Cache) => {
    const response = data.kaminoReportableUnitCreateGranadaXlc;
    if (response) {
      invalidateQuery(['kaminoReportableUnits', 'memberships'], cache); // Invalidate memberships to update the reportable unit count
    }
  },
};

export default reportableUnitMutations;